module.exports = __webpack_public_path__ + "img/image2.5c5c0872.png";